import './index.less';

import LoadingPanel from './LoadingPanel';
import SuccessPanel from './SuccessPanel';
import ErrorPanel from './ErrorPanel';

type StatusPanelSubComponents = {
  LoadingPanel: typeof LoadingPanel;
  SuccessPanel: typeof SuccessPanel;
  ErrorPanel: typeof ErrorPanel;
};

const StatusPanel: StatusPanelSubComponents = () => null;

StatusPanel.LoadingPanel = LoadingPanel;
StatusPanel.SuccessPanel = SuccessPanel;
StatusPanel.ErrorPanel = ErrorPanel;

export default StatusPanel;
